export default "__VITE_ASSET__CcZ3a5Ds__"